'use client';

export { default } from './useThemeProps';
export { default as getThemeProps } from './getThemeProps';


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/useThemeProps/index.js
// module id = 165
// module chunks = 25